/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as AppDataStoreActions from './app-data-store.actions';

/* State key */
export const featureKey = 'AppDataStore';

/* State interface */
export interface AppState {}

/* Initial values */
export const initialState: AppState = {};

export const reducer = createReducer(initialState);
